export default function Diagnostic() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-6">
          Moteur, commande ou alimentation : le diagnostic
        </h2>
        <p className="text-brand-text leading-relaxed mb-5">
          Le diagnostic d'un volet électrique en panne suit une méthodologie rigoureuse qui isole chaque maillon de la chaîne de commande. La première étape consiste à vérifier l'alimentation électrique : le technicien contrôle la tension aux bornes du moteur, vérifie que le disjoncteur n'a pas sauté et teste la continuité du câblage entre l'interrupteur et le moteur. Si l'alimentation est correcte mais le moteur ne tourne pas, le problème vient probablement du moteur lui-même ou de sa platine de commande.
        </p>
        <p className="text-brand-text leading-relaxed mb-8">
          La seconde étape concerne la commande. Pour les volets radio, le technicien teste la réception du signal avec un analyseur de fréquence et vérifie la synchronisation entre la télécommande et le récepteur embarqué. Pour les volets filaires, il contrôle la tension aux bornes de l'interrupteur et la bonne transmission des ordres de montée et descente. Enfin, la troisième étape porte sur le moteur : le technicien le teste en direct hors de l'axe pour vérifier sa rotation, sa puissance et la qualité de ses fin de course. Ce diagnostic en trois phases permet d'identifier l'élément exact à réparer, sans remplacer inutilement des composants fonctionnels.
        </p>

        <h3 className="text-xl font-semibold text-brand-blue mb-4">
          Étapes du diagnostic sur place
        </h3>
        <ul className="space-y-3">
          {[
            "Vérification de l'alimentation électrique et du disjoncteur dédié",
            "Contrôle de la tension aux bornes du moteur et test du câblage",
            "Analyse de la liaison radio ou test de l'interrupteur filaire",
            "Test du moteur hors axe pour évaluer sa rotation et sa puissance",
            "Inspection des fins de course et réinitialisation si nécessaire",
            "Vérification mécanique du tablier, des glissières et de l'enrouleur",
          ].map((item) => (
            <li key={item} className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-brand-cyan mt-0.5 flex-shrink-0">
                <i className="ri-checkbox-circle-line text-lg"></i>
              </span>
              <span className="text-brand-text text-sm md:text-base">{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}